<template>
    <Teleport to="body">
        <!-- Modal Overlay -->
        <div class="modal-overlay" v-if="props.isOpen">
            <div class="carousel p-4 pt-8">
                <!-- Visible Window -->
                <div class="carousel-window">
                    <!-- Slides Wrapper -->
                    <div class="carousel-track" :style="trackStyle">
                        <div
                            v-for="(img, index) in images"
                            :key="index"
                            class="carousel-slide"
                        >
                            <img
                                :src="img"
                                alt="carousel image"
                                class="border-2 border-black"
                            />
                        </div>
                    </div>
                </div>

                <div class="flex justify-between items-center mx-2 mt-6 mb-2">
                    <!-- Navigation -->
                    <button class="nav prev" @click="prevSlide">‹</button>

                    <button
                        class="
                            md:ml-auto
                            flex
                            py-1
                            px-8
                            border
                            font-bold
                            border-accent
                            rounded-full
                            items-center
                            text-lg
                            mx-auto
                            !text-white
                            !border-none
                        "
                        :class="{
                            'bg-gray-300': currentIndex < 3,
                            'from-primary': currentIndex == 3,
                            'bg-gradient-to-br': currentIndex == 3,
                            'to-primaryLight': currentIndex == 3,
                        }"
                        @click="emit('open')"
                        :disabled="currentIndex < 3"
                    >
                        I understand
                    </button>

                    <button class="nav next" @click="nextSlide">›</button>
                </div>

                <!-- Close Button -->
                <button class="close-btn" @click="emit('close')">✕</button>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { defineProps, ref, computed } from "vue";

const props = defineProps(["isOpen"]);
const emit = defineEmits(["close", "open"]);
// Images list
const images = ref([
    "/default-images/teams/step1.png",
    "/default-images/teams/step2.png",
    "/default-images/teams/step3.png",
    "/default-images/teams/step4.png",
]);

const currentIndex = ref(0);

// Slide width is 600px.
const trackStyle = computed(() => ({
    transform: `translateX(-${currentIndex.value * 600}px)`,
    transition: "transform 0.5s ease-in-out",
}));

function nextSlide() {
    if (currentIndex.value < images.value.length - 1) {
        currentIndex.value++;
    } else {
        currentIndex.value = 0;
    }
}

function prevSlide() {
    if (currentIndex.value > 0) {
        currentIndex.value--;
    } else {
        currentIndex.value = images.value.length - 1;
    }
}
</script>

<style scoped>
/* Overlay background */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
}

/* Modal carousel container */
.carousel {
    position: relative;
    width: 750px; /* Container is slightly larger for padding/centering */
    background: white;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.carousel-window {
    width: 600px; /* Exactly 600px viewing area */
    margin: 0 auto;
    overflow: hidden;
}

.carousel-track {
    display: flex;
    width: 100%;
}

.carousel-slide {
    width: 600px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.carousel-slide img {
    width: 600px;
    height: auto;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    display: block;
    box-sizing: border-box;
    border: 3px solid black;
}

/* Navigation Buttons */
.nav {
    background: rgba(0, 0, 0, 0.05);
    color: #444;
    border: none;
    font-size: 2.5rem;
    padding: 0 1.2rem;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.nav:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #000;
}

/* Close Button */
.close-btn {
    position: absolute;
    top: 8px;
    right: 12px;
    background: transparent;
    border: none;
    color: #bbb;
    font-size: 1.8rem;
    cursor: pointer;
    transition: color 0.2s;
}

.close-btn:hover {
    color: #666;
}
</style>
